import { render, staticRenderFns } from "./DeveloperMenu.vue?vue&type=template&id=48c6c430&"
import script from "./DeveloperMenu.vue?vue&type=script&lang=js&"
export * from "./DeveloperMenu.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports